import DragDropCard from 'components/dragDropCard'
import React, { useCallback } from 'react'
import { object, number } from 'prop-types'
import {
	editTemplateFieldRemove,
	editTemplateMove,
} from '~/states/modules/editTemplate'
import { useUpdate } from './base/widget'
import { useDispatch } from 'react-redux'
import Delete from 'components/deleteConfirm'
import { Input } from 'antd'

export const DescriptionWidget = React.memo((props) => {
	const { data, pageIndex, fieldIndex } = props
	const update = useUpdate(props)

	const dispatch = useDispatch()

	const handleRemoveField = useCallback(() => {
		dispatch(editTemplateFieldRemove({ pageIndex, fieldIndex }))
	}, [dispatch, pageIndex, fieldIndex])

	return (
		<DragDropCard
			move={editTemplateMove}
			name="form"
			index={fieldIndex}
			listIndex={pageIndex}
			style={{
				padding: '0',
			}}>
			<div
				style={{
					display: 'flex',
					width: '100%',
					alignItems: 'center',
					padding: '7px 16px 7px 40px',
					justifyContent: 'space-between',
				}}>
				<Input.TextArea
					placeholder="Descrição"
					bordered={false}
					onBlur={(e) => update({ title: e.target.value })}
					defaultValue={data.title}
					autoSize={{
						minRows: 1,
						maxRows: 6,
					}}
				/>
				<Delete
					handle={handleRemoveField}
					title="Deseja excluir esse campo?"
					onClick={(e) => e.stopPropagation()}
				/>
			</div>
		</DragDropCard>
	)
})

DescriptionWidget.propTypes = {
	data: object,
	pageIndex: number,
	fieldIndex: number,
}
